export default function ImpressumPage() {
  return (
    <div className="grid" style={{ gap: 12 }}>
      <div className="card">
        <h2 className="section-title" style={{ marginTop: 0 }}>
          Legal Notice
        </h2>
        <p style={{ marginTop: 0 }}>Information pursuant to Section 5 TMG.</p>

        <div style={{ lineHeight: 1.6 }}>
          <div>Marvin Bay</div>
          <div>c/o Online-Impressum.de #6018</div>
          <div>Europaring 90</div>
          <div>53757 Sankt Augustin</div>
          <div>Germany</div>
        </div>

        <div style={{ marginTop: 14 }}>
          <strong>Contact</strong>
          <div>
            Email: <a href="mailto:contact@marvinbay.de">contact@marvinbay.de</a>
          </div>
        </div>

        <div style={{ marginTop: 14 }}>
          <strong>Responsible for content pursuant to Section 55 para. 2 RStV</strong>
          <div>Marvin Bay, address as above</div>
        </div>

        <div style={{ marginTop: 14 }}>
          <strong>Liability for Content</strong>
          <p>
            As a service provider, I am responsible for my own content on these pages under general law
            pursuant to Section 7 para. 1 TMG. Pursuant to Sections 8 to 10 TMG, I am not obliged to
            monitor transmitted or stored third-party information or investigate circumstances indicating
            unlawful activity.
          </p>
        </div>

        <div style={{ marginTop: 14 }}>
          <strong>Liability for Links</strong>
          <p>
            This application contains links to external third-party websites. I have no influence over
            their content and therefore cannot assume liability for it. The respective provider or operator
            of the linked pages is always responsible for their content.
          </p>
        </div>

        <div style={{ marginTop: 14 }}>
          <strong>Copyright</strong>
          <p>
            Content and works created by the site operator are subject to German copyright law. Third-party
            contributions are marked as such. Reproduction, editing, distribution, or any use outside the
            limits of copyright law requires written consent from the respective author or creator.
          </p>
        </div>
      </div>
    </div>
  );
}
